import { formatarData, formatarMoeda } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";

const MOTIVO_VAGA_LABELS = {
    AUMENTO_QUADRO: "Aumento de Quadro",
    SUBSTITUICAO: "Substituição",
};

const TIPO_SELECAO_LABELS = {
    INTERNA: "Interna",
    EXTERNA: "Externa",
};

// Dados acumulados do processo — sempre visível, independentemente da etapa atual.
export default function DetalheSolicitacaoPessoal({ detalheProcesso }) {
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Dados da Vaga</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Filial" valor={detalheProcesso.unidadeNome} />
                    <Campo label="Motivo" valor={MOTIVO_VAGA_LABELS[detalheProcesso.motivoVaga] || detalheProcesso.motivoVaga} />
                    <Campo label="Vaga sigilosa" valor={detalheProcesso.vagaSigilosa ? "Sim" : "Não"} />
                    <Campo label="Cargo a preencher" valor={detalheProcesso.cargoAPreencher} />
                    <Campo label="Horário" valor={detalheProcesso.horario} />
                    <Campo label="Setor" valor={detalheProcesso.setor} />
                    <Campo label="Cidade de trabalho" valor={detalheProcesso.cidadeTrabalho} />
                    <Campo label="Adicionais" valor={(detalheProcesso.adicionais || []).join(", ")} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Motivo da Solicitação</h3>
                <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.motivoSolicitacao}</p>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Resumo das Atribuições</h3>
                <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.resumoAtribuicoes}</p>
            </div>

            {detalheProcesso.selecaoAprovadaInicio != null && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Resultado da Seleção (RH)</h3>
                    {detalheProcesso.selecaoAprovadaInicio ? (
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                            <Campo label="Tipo de Seleção" valor={TIPO_SELECAO_LABELS[detalheProcesso.tipoSelecao] || detalheProcesso.tipoSelecao} />
                            <Campo label="Cargo Preenchido" valor={detalheProcesso.cargoPreenchido} />
                            <Campo label="Área" valor={detalheProcesso.area} />
                            <Campo label="Salário" valor={formatarMoeda(detalheProcesso.salario)} />
                            <Campo label="Data de Admissão" valor={formatarData(detalheProcesso.dataAdmissao)} />
                        </div>
                    ) : (
                        <p className="text-sm text-foreground whitespace-pre-wrap">{detalheProcesso.justificativaSelecaoNaoRealizada}</p>
                    )}
                </div>
            )}
        </div>
    );
}
